import { Yield } from '../../abacus/interfaces/yield.interface'

export const toolTypeYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
